// // import React, { useState, useEffect } from "react";
// // import { motion } from "framer-motion";
// // import { Link } from "react-router-dom";
// // import {
// //   FiLinkedin,
// //   FiTwitter,
// //   FiMail,
// //   FiPhone,
// //   FiUsers,
// //   FiAward,
// //   FiBook,
// //   FiMapPin,
// // } from "react-icons/fi";
// // import axios from "axios";

// // function TeamConsultancy() {
// //   const [team, setTeam] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     fetchTeam();
// //   }, []);

// //   const fetchTeam = async () => {
// //     try {
// //       const response = await axios.get(
// //         "https://agri-back-mauve.vercel.app/api/content/public/team?teamType=consultancy"
// //       );
// //       if (response.data.success) {
// //         setTeam(response.data.data);
// //       }
// //     } catch (error) {
// //       console.error("Error fetching consultancy team:", error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <div className="min-h-screen bg-gray-50 flex items-center justify-center">
// //         <div className="text-center">
// //           <div className="w-16 h-16 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
// //           <p>Loading consultancy team...</p>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="min-h-screen bg-gray-50 pt-16">
// //       {/* Hero Section */}
// //       <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-700 text-white">
// //         <div className="container mx-auto px-4 text-center">
// //           <motion.h1
// //             initial={{ opacity: 0, y: 30 }}
// //             animate={{ opacity: 1, y: 0 }}
// //             className="text-4xl md:text-6xl font-bold mb-6"
// //           >
// //             Consultancy Team
// //           </motion.h1>
// //           <motion.p
// //             initial={{ opacity: 0, y: 30 }}
// //             animate={{ opacity: 1, y: 0 }}
// //             transition={{ delay: 0.2 }}
// //             className="text-xl md:text-2xl max-w-3xl mx-auto"
// //           >
// //             Our expert consultants bringing specialized knowledge and hands-on
// //             experience to transform agricultural practices
// //           </motion.p>
// //         </div>
// //       </section>

// //       {/* Team Navigation */}
// //       <section className="py-8 bg-white border-b">
// //         <div className="container mx-auto px-4">
// //           <div className="flex flex-col md:flex-row items-center justify-between gap-4">
// //             <div className="flex items-center gap-2 text-gray-700">
// //               <FiUsers className="w-5 h-5" />
// //               <span className="font-semibold">Team Categories:</span>
// //             </div>
// //             <div className="flex flex-wrap gap-2">
// //               <Link
// //                 to="/team/management"
// //                 className="px-6 py-2 border border-green-600 text-green-600 rounded-lg font-semibold hover:bg-green-600 hover:text-white transition-colors"
// //               >
// //                 Management Team
// //               </Link>
// //               <Link
// //                 to="/team/consultancy"
// //                 className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
// //               >
// //                 Consultancy Team
// //               </Link>
// //               <Link
// //                 to="/team"
// //                 className="px-6 py-2 border border-gray-600 text-gray-600 rounded-lg font-semibold hover:bg-gray-600 hover:text-white transition-colors"
// //               >
// //                 All Team
// //               </Link>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       {/* Consultancy Team Grid */}
// //       <section className="py-20">
// //         <div className="container mx-auto px-4">
// //           {team.length === 0 ? (
// //             <div className="text-center py-12">
// //               <div className="text-gray-400 text-6xl mb-4">🔧</div>
// //               <h3 className="text-2xl font-bold text-gray-900 mb-2">
// //                 To Access consultancy team contact either of the directors
// //               </h3>
// //               <p className="text-gray-600">
// //                 Our expert consultant profiles are waiting for you
// //               </p>
// //             </div>
// //           ) : (
// //             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
// //               {team.map((member, index) => (
// //                 <motion.div
// //                   key={member._id}
// //                   initial={{ opacity: 0, y: 20 }}
// //                   animate={{ opacity: 1, y: 0 }}
// //                   transition={{ delay: index * 0.1 }}
// //                   whileHover={{ y: -5 }}
// //                   className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300"
// //                 >
// //                   {/* Team Member Image */}
// //                   <div className="relative h-80 overflow-hidden">
// //                     {member.image ? (
// //                       <img
// //                         src={member.image}
// //                         alt={member.team?.name}
// //                         className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
// //                       />
// //                     ) : (
// //                       <div className="w-full h-full bg-gradient-to-br from-blue-500 to-cyan-600 flex items-center justify-center text-white text-2xl font-bold">
// //                         {member.team?.name
// //                           ?.split(" ")
// //                           .map((n) => n[0])
// //                           .join("")}
// //                       </div>
// //                     )}
// //                     <div className="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-20 transition-all duration-300 flex items-end justify-end p-4">
// //                       <div className="opacity-0 hover:opacity-100 transition-opacity duration-300 flex gap-2">
// //                         {member.team?.socialLinks?.linkedin && (
// //                           <a
// //                             href={member.team.socialLinks.linkedin}
// //                             target="_blank"
// //                             rel="noopener noreferrer"
// //                             className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors"
// //                           >
// //                             <FiLinkedin className="w-5 h-5 text-gray-700" />
// //                           </a>
// //                         )}
// //                         {member.team?.socialLinks?.twitter && (
// //                           <a
// //                             href={member.team.socialLinks.twitter}
// //                             target="_blank"
// //                             rel="noopener noreferrer"
// //                             className="bg-white p-2 rounded-full shadow-lg hover:bg-gray-100 transition-colors"
// //                           >
// //                             <FiTwitter className="w-5 h-5 text-blue-400" />
// //                           </a>
// //                         )}
// //                       </div>
// //                     </div>
// //                   </div>

// //                   {/* Team Member Info */}
// //                   <div className="p-6">
// //                     <div className="flex items-center justify-between mb-3">
// //                       <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
// //                         {member.team?.department}
// //                       </span>
// //                       <span className="inline-block bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full">
// //                         Consultant
// //                       </span>
// //                     </div>

// //                     <h3 className="text-xl font-bold text-gray-900 mb-2">
// //                       {member.team?.name}
// //                     </h3>

// //                     <p className="text-blue-600 font-semibold mb-3">
// //                       {member.team?.position}
// //                     </p>

// //                     <p className="text-gray-600 text-sm mb-4 line-clamp-3">
// //                       {member.team?.bio || member.description}
// //                     </p>

// //                     {member.team?.expertise &&
// //                       member.team.expertise.length > 0 && (
// //                         <div className="mb-4">
// //                           <h4 className="text-sm font-semibold text-gray-700 mb-2">
// //                             Specializations
// //                           </h4>
// //                           <div className="flex flex-wrap gap-1">
// //                             {member.team.expertise
// //                               .slice(0, 4)
// //                               .map((skill, i) => (
// //                                 <span
// //                                   key={i}
// //                                   className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded"
// //                                 >
// //                                   {skill}
// //                                 </span>
// //                               ))}
// //                             {member.team.expertise.length > 4 && (
// //                               <span className="bg-gray-100 text-gray-700 text-xs px-2 py-1 rounded">
// //                                 +{member.team.expertise.length - 4}
// //                               </span>
// //                             )}
// //                           </div>
// //                         </div>
// //                       )}

// //                     <div className="flex items-center justify-between text-sm text-gray-500">
// //                       {member.team?.email && (
// //                         <a
// //                           href={`mailto:${member.team.email}`}
// //                           className="hover:text-blue-600 transition-colors"
// //                           title="Email"
// //                         >
// //                           <FiMail className="w-4 h-4" />
// //                         </a>
// //                       )}
// //                       {member.team?.experience &&
// //                         member.team.experience.length > 0 && (
// //                           <span className="flex items-center gap-1">
// //                             <FiAward className="w-4 h-4" />
// //                             {member.team.experience.length}+ years
// //                           </span>
// //                         )}
// //                     </div>
// //                   </div>
// //                 </motion.div>
// //               ))}
// //             </div>
// //           )}
// //         </div>
// //       </section>

// //       {/* Consultancy Services */}
// //       <section className="py-20 bg-white">
// //         <div className="container mx-auto px-4">
// //           <div className="max-w-4xl mx-auto text-center">
// //             <motion.h2
// //               initial={{ opacity: 0, y: 30 }}
// //               whileInView={{ opacity: 1, y: 0 }}
// //               className="text-3xl md:text-4xl font-bold text-gray-900 mb-6"
// //             >
// //               Expert Consultation Services
// //             </motion.h2>
// //             <motion.p
// //               initial={{ opacity: 0, y: 30 }}
// //               whileInView={{ opacity: 1, y: 0 }}
// //               transition={{ delay: 0.2 }}
// //               className="text-xl text-gray-600 mb-8"
// //             >
// //               Our consultancy team provides specialized expertise in precision
// //               agriculture, IoT implementation, data analytics, and sustainable
// //               farming practices to help clients achieve their agricultural
// //               goals.
// //             </motion.p>
// //             <motion.div
// //               initial={{ opacity: 0, y: 30 }}
// //               whileInView={{ opacity: 1, y: 0 }}
// //               transition={{ delay: 0.4 }}
// //               className="flex flex-col sm:flex-row gap-4 justify-center"
// //             >
// //               <Link
// //                 to="/services"
// //                 className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
// //               >
// //                 View Our Services
// //               </Link>
// //               <Link
// //                 to="/contact"
// //                 className="border border-blue-600 text-blue-600 px-8 py-3 rounded-lg font-semibold hover:bg-blue-600 hover:text-white transition-colors"
// //               >
// //                 Request Consultation
// //               </Link>
// //             </motion.div>
// //           </div>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // }

// // export default TeamConsultancy;


// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
// import {
//   FiUsers,
//   FiAward,
//   FiBook,
//   FiMapPin,
//   FiMail,
//   FiPhone,
//   FiCpu,
//   FiDroplet,
//   FiTrendingUp,
//   FiShield,
//   FiFileText,
//   FiBarChart2,
// } from "react-icons/fi";

// function TeamConsultancy() {
//   // Predefined consultancy team profiles
//   const predefinedConsultants = [
//     {
//       id: 1,
//       name: "Agricultural Value Chain Development",
//       icon: "🔄",
//       description: "Experts in optimizing agricultural value chains from production to market, enhancing efficiency and profitability across the entire agricultural ecosystem.",
//       specializations: [
//         "Supply Chain Optimization",
//         "Market Linkages",
//         "Post-Harvest Management",
//         "Value Addition",
//         "Market Analysis",
//         "Distribution Networks"
//       ],
//       experience: "15+ years average",
//       contactNote: "Contact management for value chain specialists"
//     },
//     {
//       id: 2,
//       name: "Agricultural Biotechnology",
//       icon: "🧬",
//       description: "Specialists in cutting-edge biotechnological applications for crop improvement, genetic engineering, and sustainable agricultural practices.",
//       specializations: [
//         "Genetic Engineering",
//         "Crop Improvement",
//         "Biotech Regulations",
//         "Research & Development",
//         "Molecular Breeding",
//         "Bio-safety"
//       ],
//       experience: "12+ years average",
//       contactNote: "Available for biotech consulting projects"
//     },
//     {
//       id: 3,
//       name: "Soil and Plant Health",
//       icon: "🌱",
//       description: "Experts in soil fertility management, plant nutrition, and integrated approaches to maintain optimal soil and plant health for sustainable production.",
//       specializations: [
//         "Soil Fertility Management",
//         "Plant Nutrition",
//         "Integrated Pest Management",
//         "Soil Conservation",
//         "Crop Health Monitoring",
//         "Sustainable Practices"
//       ],
//       experience: "18+ years average",
//       contactNote: "Soil health assessment available"
//     },
//     {
//       id: 4,
//       name: "Systems Agronomy",
//       icon: "🔬",
//       description: "Specialists in holistic farming systems, crop management strategies, and integrated agricultural approaches for maximum productivity and sustainability.",
//       specializations: [
//         "Farming Systems Design",
//         "Crop Management",
//         "Precision Agriculture",
//         "Integrated Farming",
//         "Agro-ecology",
//         "System Optimization"
//       ],
//       experience: "14+ years average",
//       contactNote: "System design consultations"
//     },
//     {
//       id: 5,
//       name: "Program/Project Evaluation",
//       icon: "📊",
//       description: "Experts in monitoring, evaluation, and impact assessment of agricultural programs and projects to ensure effectiveness and continuous improvement.",
//       specializations: [
//         "Impact Assessment",
//         "Program Evaluation",
//         "Performance Metrics",
//         "M&E Systems",
//         "Data Analysis",
//         "Reporting"
//       ],
//       experience: "16+ years average",
//       contactNote: "Project evaluation services"
//     },
//     {
//       id: 6,
//       name: "Policy and Regulatory Affairs",
//       icon: "⚖️",
//       description: "Specialists in agricultural policy development, regulatory frameworks, and government relations to navigate complex agricultural policy landscapes.",
//       specializations: [
//         "Policy Development",
//         "Regulatory Compliance",
//         "Government Relations",
//         "Policy Analysis",
//         "Advocacy Strategies",
//         "Legal Frameworks"
//       ],
//       experience: "20+ years average",
//       contactNote: "Policy advisory available"
//     },
//     {
//       id: 7,
//       name: "Intellectual Property & Legal",
//       icon: "📝",
//       description: "Experts in agricultural intellectual property rights, licensing agreements, and legal frameworks to protect innovations and ensure compliance.",
//       specializations: [
//         "IP Protection",
//         "Licensing Agreements",
//         "Legal Compliance",
//         "Contract Negotiation",
//         "Patent Law",
//         "Technology Transfer"
//       ],
//       experience: "15+ years average",
//       contactNote: "IP and legal consultations"
//     },
//     {
//       id: 8,
//       name: "Advocacy & Communications",
//       icon: "📢",
//       description: "Specialists in agricultural advocacy, stakeholder engagement, and strategic communications to promote agricultural development and manage issues.",
//       specializations: [
//         "Stakeholder Engagement",
//         "Strategic Communications",
//         "Issues Management",
//         "Public Relations",
//         "Advocacy Campaigns",
//         "Media Relations"
//       ],
//       experience: "13+ years average",
//       contactNote: "Communication strategy development"
//     }
//   ];

//   const [selectedSpecialization, setSelectedSpecialization] = useState("all");

//   const filteredConsultants = selectedSpecialization === "all" 
//     ? predefinedConsultants 
//     : predefinedConsultants.filter(consultant => 
//         consultant.specializations.some(spec => 
//           spec.toLowerCase().includes(selectedSpecialization.toLowerCase())
//         )
//       );

//   const allSpecializations = [...new Set(
//     predefinedConsultants.flatMap(consultant => consultant.specializations)
//   )];

//   return (
//     <div className="min-h-screen bg-gray-50 pt-16">
//       {/* Hero Section */}
//       <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-700 text-white">
//         <div className="container mx-auto px-4 text-center">
//           <motion.h1
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             className="text-4xl md:text-6xl font-bold mb-6"
//           >
//             Expert Consultancy Team
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2 }}
//             className="text-xl md:text-2xl max-w-3xl mx-auto mb-8"
//           >
//             Access our network of specialized agricultural consultants with decades of combined experience
//           </motion.p>
//           <motion.div
//             initial={{ opacity: 0, y: 30 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.4 }}
//             className="bg-blue-500/20 backdrop-blur-sm rounded-2xl p-6 max-w-4xl mx-auto"
//           >
//             <p className="text-lg md:text-xl">
//               <strong>Note:</strong> To access our consultancy team and discuss specific project requirements, 
//               please contact our management team. We'll connect you with the right experts for your needs.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* Team Navigation */}
//       <section className="py-8 bg-white border-b">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-col md:flex-row items-center justify-between gap-4">
//             <div className="flex items-center gap-2 text-gray-700">
//               <FiUsers className="w-5 h-5" />
//               <span className="font-semibold">Team Categories:</span>
//             </div>
//             <div className="flex flex-wrap gap-2">
//               <Link
//                 to="/team/management"
//                 className="px-6 py-2 border border-green-600 text-green-600 rounded-lg font-semibold hover:bg-green-600 hover:text-white transition-colors"
//               >
//                 Management Team
//               </Link>
//               <Link
//                 to="/team/consultancy"
//                 className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
//               >
//                 Consultancy Team
//               </Link>
//               <Link
//                 to="/team"
//                 className="px-6 py-2 border border-gray-600 text-gray-600 rounded-lg font-semibold hover:bg-gray-600 hover:text-white transition-colors"
//               >
//                 All Team
//               </Link>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Specialization Filters */}
//       <section className="py-8 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
//             <div className="flex items-center gap-2">
//               <FiAward className="text-gray-400" />
//               <span className="font-medium text-gray-700">
//                 Filter by Specialization:
//               </span>
//             </div>
//             <div className="flex flex-wrap gap-2">
//               <button
//                 className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                   selectedSpecialization === "all"
//                     ? "bg-blue-600 text-white"
//                     : "bg-gray-200 text-gray-700 hover:bg-gray-300"
//                 }`}
//                 onClick={() => setSelectedSpecialization("all")}
//               >
//                 All Specializations
//               </button>
//               {allSpecializations.slice(0, 6).map((spec) => (
//                 <button
//                   key={spec}
//                   className={`px-4 py-2 rounded-lg font-medium transition-colors ${
//                     selectedSpecialization === spec
//                       ? "bg-blue-600 text-white"
//                       : "bg-gray-200 text-gray-700 hover:bg-gray-300"
//                   }`}
//                   onClick={() => setSelectedSpecialization(spec)}
//                 >
//                   {spec}
//                 </button>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Consultancy Team Grid */}
//       <section className="py-20">
//         <div className="container mx-auto px-4">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {filteredConsultants.map((consultant, index) => (
//               <motion.div
//                 key={consultant.id}
//                 initial={{ opacity: 0, y: 20 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ delay: index * 0.1 }}
//                 whileHover={{ y: -5 }}
//                 className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100"
//               >
//                 {/* Consultant Icon & Header */}
//                 <div className="bg-gradient-to-br from-blue-500 to-cyan-600 p-8 text-white text-center">
//                   <div className="text-6xl mb-4">{consultant.icon}</div>
//                   <h3 className="text-xl font-bold mb-2">{consultant.name}</h3>
//                   <div className="flex items-center justify-center gap-2 text-blue-100">
//                     <FiAward className="w-4 h-4" />
//                     <span className="text-sm font-medium">{consultant.experience}</span>
//                   </div>
//                 </div>

//                 {/* Consultant Info */}
//                 <div className="p-6">
//                   <p className="text-gray-600 text-sm mb-4 leading-relaxed">
//                     {consultant.description}
//                   </p>

//                   {/* Specializations */}
//                   <div className="mb-6">
//                     <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
//                       <FiBook className="w-4 h-4 text-blue-500" />
//                       Key Specializations
//                     </h4>
//                     <div className="flex flex-wrap gap-2">
//                       {consultant.specializations.slice(0, 4).map((skill, i) => (
//                         <span
//                           key={i}
//                           className="bg-blue-50 text-blue-700 text-xs px-3 py-1.5 rounded-full font-medium border border-blue-100"
//                         >
//                           {skill}
//                         </span>
//                       ))}
//                       {consultant.specializations.length > 4 && (
//                         <span className="bg-gray-100 text-gray-600 text-xs px-3 py-1.5 rounded-full font-medium">
//                           +{consultant.specializations.length - 4} more
//                         </span>
//                       )}
//                     </div>
//                   </div>

//                   {/* Contact Information */}
//                   <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
//                     <div className="flex items-center gap-3 text-sm text-gray-600">
//                       <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
//                         <FiMail className="w-4 h-4 text-blue-600" />
//                       </div>
//                       <div>
//                         <p className="font-medium text-gray-700">Access this expertise</p>
//                         <p className="text-xs text-gray-500">{consultant.contactNote}</p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Contact CTA Section */}
//       <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-700 text-white">
//         <div className="container mx-auto px-4">
//           <div className="max-w-4xl mx-auto text-center">
//             <motion.h2
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               className="text-3xl md:text-4xl font-bold mb-6"
//             >
//               Ready to Work with Our Experts?
//             </motion.h2>
//             <motion.p
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.2 }}
//               className="text-xl mb-8 text-blue-100"
//             >
//               Contact our management team to discuss your project requirements and get matched with the perfect consultants for your agricultural challenges.
//             </motion.p>
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.4 }}
//               className="flex flex-col sm:flex-row gap-4 justify-center items-center"
//             >
//               <Link
//                 to="/contact"
//                 className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-colors flex items-center gap-2"
//               >
//                 <FiMail className="w-5 h-5" />
//                 Contact Management Team
//               </Link>
//               <a
//                 href="tel:+254700000000"
//                 className="border border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors flex items-center gap-2"
//               >
//                 <FiPhone className="w-5 h-5" />
//                 Call Us Directly
//               </a>
//             </motion.div>
//           </div>
//         </div>
//       </section>

//       {/* Expertise Overview */}
//       <section className="py-20 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="max-w-6xl mx-auto">
//             <motion.h2
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center"
//             >
//               Our Consultancy Expertise Areas
//             </motion.h2>
            
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//               {predefinedConsultants.map((consultant, index) => (
//                 <motion.div
//                   key={consultant.id}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ delay: index * 0.1 }}
//                   className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-md transition-shadow duration-300"
//                 >
//                   <div className="text-4xl mb-4">{consultant.icon}</div>
//                   <h3 className="font-semibold text-gray-900 mb-2">{consultant.name}</h3>
//                   <p className="text-sm text-gray-600 line-clamp-2">
//                     {consultant.description}
//                   </p>
//                 </motion.div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// export default TeamConsultancy;


import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FiUsers,
  FiAward,
  FiBook,
  FiMapPin,
  FiMail,
  FiPhone,
  FiCpu,
  FiDroplet,
  FiTrendingUp,
  FiShield,
  FiFileText,
  FiBarChart2,
} from "react-icons/fi";

function TeamConsultancy() {
  // Predefined consultancy team profiles
  const predefinedConsultants = [
    {
      id: 1,
      name: "Agricultural Value Chain Development",
      icon: "🔄",
      description: "Experts in optimizing agricultural value chains from production to market, enhancing efficiency and profitability across the entire agricultural ecosystem.",
      specializations: [
        "Supply Chain Optimization",
        "Market Linkages",
        "Post-Harvest Management",
        "Value Addition",
        "Market Analysis",
        "Distribution Networks"
      ],
      experience: "15+ years average",
      contactNote: "Contact management for value chain specialists"
    },
    {
      id: 2,
      name: "Agricultural Biotechnology",
      icon: "🧬",
      description: "Specialists in cutting-edge biotechnological applications for crop improvement, genetic engineering, and sustainable agricultural practices.",
      specializations: [
        "Genetic Engineering",
        "Crop Improvement",
        "Biotech Regulations",
        "Research & Development",
        "Molecular Breeding",
        "Bio-safety"
      ],
      experience: "12+ years average",
      contactNote: "Available for biotech consulting projects"
    },
    {
      id: 3,
      name: "Soil and Plant Health",
      icon: "🌱",
      description: "Experts in soil fertility management, plant nutrition, and integrated approaches to maintain optimal soil and plant health for sustainable production.",
      specializations: [
        "Soil Fertility Management",
        "Plant Nutrition",
        "Integrated Pest Management",
        "Soil Conservation",
        "Crop Health Monitoring",
        "Sustainable Practices"
      ],
      experience: "18+ years average",
      contactNote: "Soil health assessment available"
    },
    {
      id: 4,
      name: "Systems Agronomy",
      icon: "🔬",
      description: "Specialists in holistic farming systems, crop management strategies, and integrated agricultural approaches for maximum productivity and sustainability.",
      specializations: [
        "Farming Systems Design",
        "Crop Management",
        "Precision Agriculture",
        "Integrated Farming",
        "Agro-ecology",
        "System Optimization"
      ],
      experience: "14+ years average",
      contactNote: "System design consultations"
    },
    {
      id: 5,
      name: "Program/Project Evaluation",
      icon: "📊",
      description: "Experts in monitoring, evaluation, and impact assessment of agricultural programs and projects to ensure effectiveness and continuous improvement.",
      specializations: [
        "Impact Assessment",
        "Program Evaluation",
        "Performance Metrics",
        "M&E Systems",
        "Data Analysis",
        "Reporting"
      ],
      experience: "16+ years average",
      contactNote: "Project evaluation services"
    },
    {
      id: 6,
      name: "Policy and Regulatory Affairs",
      icon: "⚖️",
      description: "Specialists in agricultural policy development, regulatory frameworks, and government relations to navigate complex agricultural policy landscapes.",
      specializations: [
        "Policy Development",
        "Regulatory Compliance",
        "Government Relations",
        "Policy Analysis",
        "Advocacy Strategies",
        "Legal Frameworks"
      ],
      experience: "20+ years average",
      contactNote: "Policy advisory available"
    },
    {
      id: 7,
      name: "Intellectual Property & Legal",
      icon: "📝",
      description: "Experts in agricultural intellectual property rights, licensing agreements, and legal frameworks to protect innovations and ensure compliance.",
      specializations: [
        "IP Protection",
        "Licensing Agreements",
        "Legal Compliance",
        "Contract Negotiation",
        "Patent Law",
        "Technology Transfer"
      ],
      experience: "15+ years average",
      contactNote: "IP and legal consultations"
    },
    {
      id: 8,
      name: "Advocacy & Communications",
      icon: "📢",
      description: "Specialists in agricultural advocacy, stakeholder engagement, and strategic communications to promote agricultural development and manage issues.",
      specializations: [
        "Stakeholder Engagement",
        "Strategic Communications",
        "Issues Management",
        "Public Relations",
        "Advocacy Campaigns",
        "Media Relations"
      ],
      experience: "13+ years average",
      contactNote: "Communication strategy development"
    }
  ];

  const [selectedSpecialization, setSelectedSpecialization] = useState("all");

  // Fixed filter function - exact match
  const filteredConsultants = selectedSpecialization === "all" 
    ? predefinedConsultants 
    : predefinedConsultants.filter(consultant => 
        consultant.specializations.some(spec => 
          spec.toLowerCase() === selectedSpecialization.toLowerCase()
        )
      );

  // Get unique specializations for filters
  const allSpecializations = [...new Set(
    predefinedConsultants.flatMap(consultant => consultant.specializations)
  )];

  return (
    <div className="min-h-screen bg-gray-50 pt-16">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-green-600 to-emerald-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-6xl font-bold mb-6"
          >
            Expert Consultancy Team
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="text-xl md:text-2xl max-w-3xl mx-auto mb-8"
          >
            Access our network of specialized agricultural consultants with decades of combined experience
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="bg-green-500/20 backdrop-blur-sm rounded-2xl p-6 max-w-4xl mx-auto"
          >
            <p className="text-lg md:text-xl">
              <strong>Note:</strong> To access our consultancy team and discuss specific project requirements, 
              please contact our management team. We'll connect you with the right experts for your needs.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Team Navigation */}
      <section className="py-8 bg-white border-b">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-gray-700">
              <FiUsers className="w-5 h-5" />
              <span className="font-semibold">Team Categories:</span>
            </div>
            <div className="flex flex-wrap gap-2">
              <Link
                to="/team/management"
                className="px-6 py-2 border border-green-600 text-green-600 rounded-lg font-semibold hover:bg-green-600 hover:text-white transition-colors"
              >
                Management Team
              </Link>
              <Link
                to="/team/consultancy"
                className="px-6 py-2 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition-colors"
              >
                Consultancy Team
              </Link>
              <Link
                to="/team"
                className="px-6 py-2 border border-gray-600 text-gray-600 rounded-lg font-semibold hover:bg-gray-600 hover:text-white transition-colors"
              >
                All Team
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Specialization Filters */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <FiAward className="text-gray-400" />
              <span className="font-medium text-gray-700">
                Filter by Specialization:
              </span>
            </div>
            <div className="flex flex-wrap gap-2">
              <button
                className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                  selectedSpecialization === "all"
                    ? "bg-green-600 text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                }`}
                onClick={() => setSelectedSpecialization("all")}
              >
                All Specializations
              </button>
              {allSpecializations.slice(0, 6).map((spec) => (
                <button
                  key={spec}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                    selectedSpecialization === spec
                      ? "bg-green-600 text-white"
                      : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                  }`}
                  onClick={() => setSelectedSpecialization(spec)}
                >
                  {spec}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Consultancy Team Grid */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredConsultants.map((consultant, index) => (
              <motion.div
                key={consultant.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ y: -5 }}
                className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                {/* Consultant Icon & Header */}
                <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-8 text-white text-center">
                  <div className="text-6xl mb-4">{consultant.icon}</div>
                  <h3 className="text-xl font-bold mb-2">{consultant.name}</h3>
                  <div className="flex items-center justify-center gap-2 text-green-100">
                    <FiAward className="w-4 h-4" />
                    <span className="text-sm font-medium">{consultant.experience}</span>
                  </div>
                </div>

                {/* Consultant Info */}
                <div className="p-6">
                  <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                    {consultant.description}
                  </p>

                  {/* Specializations */}
                  <div className="mb-6">
                    <h4 className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                      <FiBook className="w-4 h-4 text-green-500" />
                      Key Specializations
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {consultant.specializations.slice(0, 4).map((skill, i) => (
                        <span
                          key={i}
                          className="bg-green-50 text-green-700 text-xs px-3 py-1.5 rounded-full font-medium border border-green-100"
                        >
                          {skill}
                        </span>
                      ))}
                      {consultant.specializations.length > 4 && (
                        <span className="bg-gray-100 text-gray-600 text-xs px-3 py-1.5 rounded-full font-medium">
                          +{consultant.specializations.length - 4} more
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Contact Information */}
                  <div className="bg-gray-50 rounded-lg p-4 border border-gray-200">
                    <div className="flex items-center gap-3 text-sm text-gray-600">
                      <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                        <FiMail className="w-4 h-4 text-green-600" />
                      </div>
                      <div>
                        <p className="font-medium text-gray-700">Access this expertise</p>
                        <p className="text-xs text-gray-500">{consultant.contactNote}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-20 bg-gradient-to-br from-green-600 to-emerald-700 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-3xl md:text-4xl font-bold mb-6"
            >
              Ready to Work with Our Experts?
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="text-xl mb-8 text-green-100"
            >
              Contact our management team to discuss your project requirements and get matched with the perfect consultants for your agricultural challenges.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            >
              <Link
                to="/contact"
                className="bg-white text-green-600 px-8 py-4 rounded-lg font-semibold hover:bg-green-50 transition-colors flex items-center gap-2"
              >
                <FiMail className="w-5 h-5" />
                Contact Management Team
              </Link>
              <a
                href="tel:+254700000000"
                className="border border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-green-600 transition-colors flex items-center gap-2"
              >
                <FiPhone className="w-5 h-5" />
                Call Us Directly
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Expertise Overview */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center"
            >
              Our Consultancy Expertise Areas
            </motion.h2>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {predefinedConsultants.map((consultant, index) => (
                <motion.div
                  key={consultant.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="bg-gray-50 rounded-xl p-6 text-center hover:shadow-md transition-shadow duration-300 border border-gray-200"
                >
                  <div className="text-4xl mb-4">{consultant.icon}</div>
                  <h3 className="font-semibold text-gray-900 mb-2 text-sm">{consultant.name}</h3>
                  <p className="text-xs text-gray-600 line-clamp-3">
                    {consultant.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TeamConsultancy;